import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { BasicResponse } from "../model/basic-response";
import { RemoteDeviceInterfaceAPI, RemoteDeviceInterface, linkedGidListInterfaceAPI, RemoteDeviceGidListInterface, ServicePointSetupAPI } from "../model/remote-device";
import { ConfigService } from "./config.service";


@Injectable({
  providedIn: 'root',
})
export class RemoteDeviceService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(ConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL = config.REST_SERVER_HOST + '/api/amassapp';
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllRemoteDevice(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    globalId: number,
    serialNo: string
  ): Observable<RemoteDeviceInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    const filters = {
      globalId,
      serialNo,
    };
    console.log('filters:');
    console.log(filters);
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<RemoteDeviceInterfaceAPI>(
        `${this.URL}/rde/getallremotedevice/${pageIndex}/${pageSize}/${
          sortActive ? sortActive : 'id'
        }/${sort ? sort : 'asc'}/${globalId ? globalId : 0}/${
          serialNo ? serialNo : 0
        }`,
        filters,
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  getAllRemoteDeviceGidList(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    refRDEID: number
  ): Observable<linkedGidListInterfaceAPI> {
    const headers = this.headers;
    const filters = {
      refRDEID,
    };
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<linkedGidListInterfaceAPI>(
        `${this.URL}/rde/getallremotedevicegidlist/${pageIndex}/${pageSize}/${
          sortActive ? sortActive : 'id'
        }/${sort ? sort : 'asc'}`,
        filters,
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  unlinkRemoteDeviceGidList(rdg: any): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update rdg: ' + JSON.stringify(rdg));
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<BasicResponse>(`${this.URL}/rde/unlinkremotedevicegidlist`, rdg, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  getRemoteDeviceGidList(id: number): Observable<linkedGidListInterfaceAPI> {
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<linkedGidListInterfaceAPI>(
        `${this.URL}/rde/getallremotedevicegidlist/${id ? id : 0}`,
        { headers }
      )
      .pipe(catchError(this.handleError));
  }

  getRemoteDevice(id: number): Observable<RemoteDeviceInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient
      .post<RemoteDeviceInterface>(`${this.URL}/rde/getremotedevice/${id}`, {}, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  updateRDE(rde: RemoteDeviceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update rde: ' + JSON.stringify(rde));
    return this.httpClient
      .post<BasicResponse>(`${this.URL}/rde/updateremotedevice`, rde, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  createRDE(rde: RemoteDeviceInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tok: ' + JSON.stringify(rde));
    return this.httpClient
      .post<BasicResponse>(`${this.URL}/rde/createremotedevice`, rde, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  createRDG(rde: RemoteDeviceGidListInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('create rdelist: ' + JSON.stringify(rde));
    return this.httpClient
      .post<BasicResponse>(`${this.URL}/rde/createremotedevicegidlist`, rde, {
        headers,
      })
      .pipe(catchError(this.handleError));
  }

  // Added service for GIDLIST                  07/14/2023 AK
  // getAllSPS(): Observable<RemoteDeviceInterfaceAPI> {
  //   const headers = this.headers;
  //   return this.httpClient.get<RemoteDeviceInterfaceAPI>(`${this.URL}/sps/spslist`,
  //       {headers});
  // }

  // See C001 - 2026-07-27 - JB
  // getAllSPS(): Observable<ServicePointSetupAPI> {
  //   const headers = this.headers;
  //   return this.httpClient
  //     .get<ServicePointSetupAPI>(`${this.URL}/rde/getallsps`, { headers })
  //     .pipe(catchError(this.handleError));
  // }
  getAllSPS(
    globalId: string = '',
    servicePointName: string = ''
  ): Observable<ServicePointSetupAPI> {
    const headers = this.headers;
    let params = new HttpParams();
    if (globalId) {
      params = params.set('globalId', globalId);
    }
    if (servicePointName) {
      params = params.set('servicePointName', servicePointName);
    }
    return this.httpClient
      .get<ServicePointSetupAPI>(`${this.URL}/rde/getallsps`, {
        headers,
        params,
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Updated getAllSPS() in RemoteDeviceService to accept optional globalId and servicePointName query filters and pass them as HttpParams on GET /rde/getallsps. Previous behavior: getAllSPS() always requested the full unfiltered SPS list with no query parameters, which made large GID dropdowns unusable. New behavior: Callers can pass optional globalId and/or servicePointName strings; non-empty values are appended as query params while empty defaults keep the unfiltered call for backward compatibility. Reason: Ticket #15290 / #8585 — backend now supports LIKE/contains filters so Remote Device GID selects can search server-side. Context: Auth-suite portaladmin-ss Remote Device edit GID search. Impact: Existing no-arg getAllSPS() callers (e.g. table views) continue to work; edit-view search can narrow options via API. - 2026-07-27 - JB

